import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'

export const PrefooterSeo = ({ title, columns }) => {
   useLayoutEffect(() => {
      var observer = ''
      const insertSeoFooter = () => {
         const sitemap = document.getElementById('o-footer-sitemap')
         const accesDirect = document.getElementById('o-footer-accesDirect')
         const target = sitemap || accesDirect
         if (target) {
            if (observer !== '') observer.disconnect()
            const prefooterSeo = document.getElementById('prefooterSeo')
            if (sitemap) {
               sitemap.parentNode.insertBefore(prefooterSeo, sitemap.nextSibling)
            } else {
               accesDirect.parentNode.insertBefore(prefooterSeo, accesDirect)
            }
            prefooterSeo.classList.remove('d-none')
         }
      }

      let isFooterReady = document.getElementById('o-footer-sitemap') !== null || document.getElementById('o-footer-accesDirect') !== null ? true : false

      if (isFooterReady) {
         insertSeoFooter()
      } else {
         observer = new MutationObserver(insertSeoFooter)
         let footerWrapper = document.getElementById('footer-wrapper')
         if (footerWrapper) {
            observer.observe(footerWrapper, { subtree: true, childList: true })
         }
      }
   }, [])

   return (
      <div id="prefooterSeo" class="o-footer-sitemap prefooter o-marge d-none">
         <div class="o-footer-content" data-widthlimit="">
            <div>
               <h3 class="m-0 pt-1 lead font-weight-bold prefooter-title">{title}</h3>
               <ul class="prefooter-cols">
                  {columns.map((item) => {
                     return (
                        <li class="o-footer-sitemap-column">
                           <ul>
                              {item.map((link) => {
                                 return (
                                    <li>
                                       <a href={link.URL}>
                                          <span class="o-link-text">
                                             <span>{link.label}</span>
                                          </span>
                                       </a>
                                    </li>
                                 )
                              })}
                           </ul>
                        </li>
                     )
                  })}
               </ul>
            </div>
         </div>
      </div>
   )
}
